export default "__VITE_ASSET__098c71c1__"